export const AUTH_ACTION_TYPES = {
    AUTH_START: "AUTH_START",
    AUTH_SUCCESS: "AUTH_SUCCESS",
    AUTH_FAILURE: "AUTH_FAILURE",
    AUTH_CHALLENGE: "AUTH_CHALLENGE",
    AUTH_LOGOUT: "AUTH_LOGOUT",
    CLEAR_ERROR: "CLEAR_ERROR",
    CLEAR_CHALLENGE: "CLEAR_CHALLENGE",
    SET_INITIALIZED: "SET_INITIALIZED",
    CLEAR_MFA_SETUP_REQUIRED: "CLEAR_MFA_SETUP_REQUIRED"
};
